'use es6';

export default Object.freeze({
  DESKTOP: 'desktop',
  TABLET_PORTRAIT: 'tablet-portrait',
  TABLET_LANDSCAPE: 'tablet-landscape',
  MOBILE_PORTRAIT: 'mobile-portrait',
  MOBILE_LANDSCAPE: 'mobile-landscape'
});